import { IPayeeTaxFormResponse } from "@wingspanhq/payments/dist/interfaces/api/taxForm";

export function selectorPayeeTaxFormCountry(taxForm: IPayeeTaxFormResponse) {
  return (
    taxForm?.data?.w9Info?.country ??
    (taxForm.payee?.profile?.address?.country as string)
  );
}
